import { SaveAlt, Search } from "@material-ui/icons";
import { Fab, Grid, Tooltip } from "@mui/material";
import DateRangePicker from "components/date-picker/DateRangePicker";
import Select from "components/select/Select";
import SelectProvinceType from "components/select-province-type/SelectProvinceType";
import { ALL_OPTION } from "constant";
import { useFormik } from "formik";
import { useGetListPhoneNumberV1 } from "service/query/phone-number.query";
import * as Yup from "yup";

const ReportInboundPerformanceFilter = ({
  onSubmit,
  onExport,
  disabledExport,
}) => {
  const formik = useFormik({
    initialValues: {
      phoneNumber: [ALL_OPTION.value],
      dateRange: [new Date(), new Date()],
      typeProvince: "",
      code: [ALL_OPTION.value],
    },
    validationSchema: Yup.object().shape({
      typeProvince: Yup.string().required("Không được trống"),
      code: Yup.array().min(1, "Không được trống"),
      phoneNumber: Yup.array().min(1, "Không được trống"),
    }),
    onSubmit,
  });

  const { data: listPhoneNumber } = useGetListPhoneNumberV1();

  return (
    <form onSubmit={formik.handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={5}>
          <DateRangePicker
            value={formik.values.dateRange}
            onChange={(value) => formik.setFieldValue("dateRange", value)}
          />
        </Grid>

        <Grid item xs={5}>
          <SelectProvinceType formik={formik} />
        </Grid>

        <Grid item xs={2}>
          <Select
            label="Đầu số"
            onChange={(value) => {
              formik.setFieldValue("phoneNumber", value);
            }}
            showAllOption
            isMulti
            value={formik.values.phoneNumber}
            options={listPhoneNumber?.map((item) => ({
              value: item._id,
              label: item._id,
            }))}
            error={formik.touched.phoneNumber && formik.errors.phoneNumber}
          />
        </Grid>

        <Grid item xs={3}>
          <Tooltip title="Tìm kiếm">
            <Fab color="primary" aria-label="Search" type="submit">
              <Search />
            </Fab>
          </Tooltip>
          <Tooltip title="Tải báo cáo">
            <Fab
              color="primary"
              aria-label="Search"
              style={{ marginLeft: "10px" }}
              disabled={disabledExport}
              onClick={onExport}>
              <SaveAlt />
            </Fab>
          </Tooltip>
        </Grid>
      </Grid>
    </form>
  );
};

export default ReportInboundPerformanceFilter;
